// removed by extract-text-webpack-plugin
module.exports = {"Coconut":"#F4F7FA","container":"G689b78","layoutContainer":"Gd3a1ee","pageContainer":"G12c299"};